module.exports = __webpack_public_path__ + "img/2ne.e85ed172.svg";